import { debounce } from "lodash";
import { useMemo, useState } from "react";

import { useGetRuleFilterPositions } from "~/entity/CombinationRules";

export const useRulePositionsSelectOptions = () => {
  const [searchText, setSearchText] = useState("");
  const { positions, isLoading } = useGetRuleFilterPositions();

  const searchOptions = useMemo(
    () => debounce((text: string) => setSearchText(text), 300),
    [],
  );

  const options = useMemo(() => {
    const normalizedSearch = searchText.trim().toLowerCase();

    return (positions ?? [])
      .filter(({ code, name }) => {
        if (!normalizedSearch) return true;
        const label = `${code ? `${code}. ` : ""}${name}`.toLowerCase();
        return label.includes(normalizedSearch);
      })
      .map(({ id, code, name }) => ({
        value: id,
        label: code ? `${code}. ${name}` : name,
      }));
  }, [positions, searchText]);

  return { options, isLoading, searchOptions };
};
